export function initCustomVideoPlayers() {
    const videos = document.querySelectorAll('.cmp-videoplayer');

    videos.forEach(wrapper => {
        const video = wrapper.querySelector('video');
        const playBtn = wrapper.querySelector('.cmp-videoplayer__play-button');

        if (!video || !playBtn) return;

        playBtn.addEventListener('click', () => {
            video.play();
            playBtn.style.display = 'none';
        });

        video.addEventListener('play', () => {
            playBtn.style.display = 'none';
        });
    });
}